import React from 'react';
import { Link } from 'react-router-dom';

const LandingFooter = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="landing-footer">
            <div className="landing-footer-content">
                <Link to="/" className="landing-footer-logo">
                    <div className="landing-footer-logo-icon">⚡</div>
                    <span>Vitisiti</span>
                </Link>

                <div className="landing-footer-links">
                    <a href="#features" className="landing-footer-link">Features</a>
                    <Link to="/pricing" className="landing-footer-link">Pricing</Link>
                    <Link to="/privacy-policy" className="landing-footer-link">Privacy Policy</Link>
                    <Link to="/terms-of-service" className="landing-footer-link">Terms of Service</Link>
                    <Link to="/login" className="landing-footer-link">Sign In</Link>
                </div>

                <div className="landing-footer-copyright">
                    &copy; {currentYear} Vitisiti. All rights reserved.
                </div>
            </div>
        </footer>
    );
};

export default LandingFooter;
